var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"intersections"},_vm._l((_vm.intersections),function(intersection,i){return _c('div',{key:'intersection' + i,class:{
      intersection: true,
      'intersection-top': intersection.position === 'top',
      'intersection-bottom': intersection.position === 'bottom'
    },style:({
      left: intersection.x - _vm.intersectionWidth / 2 + 'px',
      width: _vm.intersectionWidth + 'px'
    })},[_c('span',[_vm._v(" "+_vm._s(intersection.name)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }